import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'

import { SkeletonHeader, SkeletonPlayer, SkeletonRoot, SkeletonText } from './styled'

export default function SupportVideoDetailsSkeleton() {
  return (
    <SkeletonRoot>
      <SkeletonHeader>
        <BaseSkeleton height={18} width="min(360px, 78vw)" />
        <BaseSkeleton height={44} width="min(620px, 88vw)" />
      </SkeletonHeader>
      <SkeletonPlayer>
        <BaseSkeleton height="100%" width="100%" borderRadius={18} />
      </SkeletonPlayer>
      <SkeletonText>
        <BaseSkeleton height={26} width={180} />
        <BaseSkeleton height={16} width="92%" />
        <BaseSkeleton height={16} width="76%" />
      </SkeletonText>
    </SkeletonRoot>
  )
}
